import type { License } from "../../../../../../store/reseller-admin/licensesStore";
import type { ThemeClasses } from "../types";
import LicenseGridCard from "./LicenseGridCard";
import LicenseListRow from "./LicenseListRow";

interface LicenseListProps {
  licenses: License[];
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  selectedView: "grid" | "list";
  onDetails: (license: License) => void;
  onEdit: (license: License) => void;
  onDelete: (license: License) => void;
}

export default function LicenseList({
  licenses,
  themeClasses,
  isDarkMode,
  selectedView,
  onDetails,
  onEdit,
  onDelete,
}: LicenseListProps) {
  if (licenses.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <i className={`ri-key-2-line text-5xl ${themeClasses.textSecondary} mb-4`}></i>
        <h3 className={`text-lg font-semibold ${themeClasses.text} mb-2`}>
          No hay licencias
        </h3>
        <p className={`text-sm ${themeClasses.textSecondary}`}>
          Crea tu primera licencia para comenzar
        </p>
      </div>
    );
  }

  if (selectedView === "grid") {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {licenses.map((license) => (
          <LicenseGridCard
            key={license.id}
            license={license}
            themeClasses={themeClasses}
            isDarkMode={isDarkMode}
            onDetails={onDetails}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {licenses.map((license) => (
        <LicenseListRow
          key={license.id}
          license={license}
          themeClasses={themeClasses}
          isDarkMode={isDarkMode}
          onDetails={onDetails}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
